export const validateSellForm =(formData)=>{
let error={}
if (!formData.firstName.trim()) {
    error.firstName = "First Name is required";
  }
   if (!formData.lastName.trim()) {
    error.lastName = "Last Name is required";
  }
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!formData.email) {
    error.email = "Email is required";
  } else if (!emailRegex.test(formData.email)) {
    error.email = "Enter a valid email address";
  }
  if (!formData.contactNumber) {
    error.contactNumber = "Contact number is required";
  } else if (formData.contactNumber.length < 13) {
    error.contactNumber = "Add a Contact number valid number";
  }


  if (!formData.whatsappNumber) {
    error.whatsappNumber = "WhatsApp number is required";
  } else if (formData.whatsappNumber.length < 13) {
    error.whatsappNumber = "Add WhatsApp number valid number";
  }
  if (!formData.PropertyName.trim()) {
    error.PropertyName = "Property Name is required";
  }

  if(!formData.propertyType.trim())
  {
    error.propertyType="Property type is required"
  }

  if(!formData.apartmentType.trim())
  {
    error.apartmentType="Apartment type is required"
  }
  if(!formData.status.trim())
  {
    error.status="Property Status is required"
  }
  

  if(!formData.bedRoomType.trim())
  {
    error.bedRoomType="BedRoom/BHK type is required"
  }


  if(!formData.propertyLocation.trim())
  {
    error.propertyLocation="Property location is required"
  }else if (formData.propertyLocation.length < 10) {
    error.propertyLocation =
      "Property location must be at least 10 characters.";
  } else if (formData.propertyLocation.length > 255) {
    error.propertyLocation =
      "Property location must not exceed 255 characters.";
  }


  if(!formData.propertyDetails.trim())
  {
    error.propertyDetails="Property Details is required"
  }
  else if (formData.propertyDetails.length < 10) {
    error.propertyDetails =
      "Property details must be at least 10 characters.";
  } else if (formData.propertyDetails.length > 400) {
    error.propertyDetails =
      "Property details must not exceed 400 characters.";
  }


  

return error;

}